export class TravelExpenseCoefficient {
    id: number;
    active: boolean;
    distanceKM: number;
    weeklyA5 : number;
    weeklyA6 : number;
    weeklyA7 : number;
    weeklyIndemnities : number;
  }
